import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import CreateTeamForm from './CreateTeamForm';

const CreateTeamModal = ({ submitHandler = () => {}, team = null }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <div>
      <span
        className="cursor-pointer"
        onClick={() => {
          setIsOpenModal(true);
        }}
      >
        {team ? (
          <>
            <div className="d-flex align-items-center gap-1">
              <i className="bx bx-pencil"></i> Edit
            </div>
          </>
        ) : (
          <>
            <i className="bx bx-plus"></i> Add New Field
          </>
        )}
      </span>
      <Modal
        isOpen={isOpenModal}
        toggle={() => {
          setIsOpenModal(!isOpenModal);
        }}
        centered={true}
        size="modal-fullscreen"
        className="modal-fullscreen"
      >
        <ModalHeader
          className="modal-title pb-3 bg-light"
          toggle={() => {
            setIsOpenModal(!isOpenModal);
          }}
        >
          Create new Team
        </ModalHeader>
        <ModalBody className="p-5">
          <CreateTeamForm
            submitHandler={() => {
              setIsOpenModal(false);
              submitHandler();
            }}
            team={team}
            closeHandler={() => setIsOpenModal(false)}
          />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CreateTeamModal;
